import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Action, Pagination } from '../../components/';

const PostList = ({ paginationPageSize, posts, headingTag: HeadingTag = 'strong', Header, ...rest }) => {
  const [paginationCurrentPage, setPaginationPage] = useState(1);
  const pageStart = (paginationCurrentPage - 1) * paginationPageSize;
  const visiblePosts = posts.slice(pageStart, pageStart + paginationPageSize);

  return (
    <>
      <div>
        {visiblePosts.map(({ postId, title, link, date, excerpt, featuredImage, author, categories }) => (
          <article key={postId}>
            <Header author={author} date={date} categories={categories?.nodes || []} />
            <HeadingTag>
              <Action href={link}>{title}</Action>
            </HeadingTag>
            {!!featuredImage && featuredImage.src && <img {...featuredImage} loading="lazy" />}
            {!!excerpt && <div dangerouslySetInnerHTML={{ __html: excerpt }} />}
          </article>
        ))}
      </div>
      <Pagination
        aria-label="Pagination Navigation"
        currentPage={paginationCurrentPage}
        numberOfItems={posts.length}
        pageSize={paginationPageSize}
        type="button"
        setPage={(page, evt) => {
          evt.preventDefault();

          setPaginationPage(page);
        }}
        {...rest}
      />
    </>
  );
};

PostList.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object).isRequired,
  paginationPageSize: PropTypes.number.isRequired,
  Header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
};

export default PostList;
